module.exports = __webpack_public_path__ + "static/img/wechat_logo.10dd7a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/wechat_logo.png
// module id = 2ma6
// module chunks = 1